/** Grouped navigation for Admin Portal (single-page; IDs match section render keys). */
export const ADMIN_NAV_GROUPS = [
  {
    groupId: 'registrations',
    groupLabel: 'Registrations & forms',
    items: [
      { id: 'gladiatorGames', label: 'Gladiator Games' },
      { id: 'tryouts', label: 'Tryouts' },
      { id: 'springHockey', label: 'Spring Hockey' },
      { id: 'scheduledGames', label: 'Schedule a game' },
      { id: 'submissions', label: 'Join Us' },
      { id: 'uploadedDocs', label: 'Uploaded documents' },
    ],
  },
  {
    groupId: 'parents',
    groupLabel: 'Parents & chat',
    items: [
      { id: 'parentChat', label: 'Team chat' },
      { id: 'parentPin', label: 'Parent signup PIN' },
      { id: 'parentAccounts', label: 'Parent accounts & dues' },
      { id: 'parentSurveys', label: 'Parent surveys' },
    ],
  },
  {
    groupId: 'team',
    groupLabel: 'Team content & stats',
    items: [
      { id: 'teamSchedule', label: 'Team schedule' },
      { id: 'teamRoster', label: 'Team roster' },
      { id: 'teamCoaches', label: 'Team coaches' },
      { id: 'sponsors', label: 'Sponsors' },
      { id: 'chalkTalk', label: 'Chalk Talk drills' },
      { id: 'gladiatorsTv', label: 'Gladiators TV' },
      { id: 'liveScoreboard', label: 'Live scoreboard' },
      { id: 'practiceLines', label: 'Practice line builder' },
      { id: 'gameHistory', label: 'Game history' },
      { id: 'gladiatorGazette', label: 'Gladiator Gazette' },
      { id: 'memoryLeaderboard', label: 'Memory game leaderboard' },
    ],
  },
  {
    groupId: 'media',
    groupLabel: 'Media',
    items: [{ id: 'gallery', label: 'Gallery photos' }],
  },
];

export const ALL_ADMIN_SECTION_IDS = ADMIN_NAV_GROUPS.flatMap((g) => g.items.map((i) => i.id));

/** Session / routing id for dashboard cards */
export const OVERVIEW_SECTION_ID = 'overview';

/** Staff management (super-admins only) */
export const STAFF_SECTION_ID = 'staff';

const SUPER_SENTINELS = new Set(['*', 'all']);

/** Firestore adminUsers.sections uses same strings as nav item ids, plus '*' or 'all' for full access, plus 'staff' for user management. */
export function isSuperStaffFromSections(sections) {
  if (!Array.isArray(sections)) return false;
  return sections.some((s) => SUPER_SENTINELS.has(String(s)));
}

/** Expand sections field into a Set of UI section ids the user may open (includes overview when they have any tool). */
export function expandAllowedSectionSet(sectionsFromDoc) {
  const raw = Array.isArray(sectionsFromDoc) ? sectionsFromDoc.map((x) => String(x)) : [];
  const out = new Set();
  if (raw.some((s) => SUPER_SENTINELS.has(s))) {
    out.add(OVERVIEW_SECTION_ID);
    out.add(STAFF_SECTION_ID);
    ALL_ADMIN_SECTION_IDS.forEach((id) => out.add(id));
    return out;
  }
  raw.forEach((s) => {
    if (s === OVERVIEW_SECTION_ID) out.add(OVERVIEW_SECTION_ID);
    else if (s === STAFF_SECTION_ID) out.add(STAFF_SECTION_ID);
    else if (ALL_ADMIN_SECTION_IDS.includes(s)) out.add(s);
  });
  // Staff who can manage game history can also pull Gazettes.
  if (out.has('gameHistory')) out.add('gladiatorGazette');
  // Parent-accounts staff can manage the public roster (same write permission in rules).
  if (out.has('parentAccounts')) out.add('teamRoster');
  if (out.has('teamRoster')) out.add('teamCoaches');
  if (out.has(STAFF_SECTION_ID) || ALL_ADMIN_SECTION_IDS.some((id) => out.has(id))) {
    out.add(OVERVIEW_SECTION_ID);
  }
  return out;
}

export function filterNavGroupsForStaff(allowedSet) {
  const staffGroup = {
    groupId: 'staff',
    groupLabel: 'Staff',
    items: [{ id: STAFF_SECTION_ID, label: 'Staff accounts' }],
  };
  const base = ADMIN_NAV_GROUPS.map((g) => ({
    ...g,
    items: g.items.filter((item) => allowedSet.has(item.id)),
  })).filter((g) => g.items.length > 0);
  if (allowedSet.has(STAFF_SECTION_ID)) {
    return [...base, staffGroup];
  }
  return base;
}
